type ParsedGs1 = {
  gtin?: string
  lotNumber?: string
  expirationDate?: Date
}

export function parseGs1(raw: string): ParsedGs1 | null {
  const normalized = raw.split(String.fromCharCode(29)).join('|')
  let i = 0
  const result: ParsedGs1 = {}
  while (i < normalized.length - 1) {
    const ai = normalized.slice(i, i + 2)
    switch (ai) {
      case '01': // GTIN (14)
        result.gtin = normalized.slice(i + 2, i + 16)
        i += 16
        break
      case '17': { // Expiration YYMMDD
        const year = 2000 + Number(normalized.slice(i + 2, i + 4))
        const month = Number(normalized.slice(i + 4, i + 6)) - 1
        const day = Number(normalized.slice(i + 6, i + 8))
        result.expirationDate = new Date(year, month, day)
        i += 8
        break
      }
      case '10': { // Lot number (variable length)
        const start = i + 2
        const end = normalized.indexOf('|', start)
        result.lotNumber =
          end === -1
            ? normalized.slice(start)
            : normalized.slice(start, end)
        i = end === -1 ? normalized.length : end + 1
        break
      }
      default:
        // No relevant GS1 Application Identifier
        i += 1
        break
    }
  }
  return result.gtin ? result : null
}
